import { useState } from 'react';

export const useAdditionalFilterBarState = ({ logger, handleUsage }) => {
  const [showAdditionalFilterBar, setShowAdditionalFilterBar] = useState(false);
  const toggleFilterBar = () => {
    logger.logTrace('toggle the filter bar', { showAdditionalFilterBar: !showAdditionalFilterBar });
    if (handleUsage) {
      handleUsage();
    }
    setShowAdditionalFilterBar(!showAdditionalFilterBar);
  };

  return {
    toggleFilterBar,
    showAdditionalFilterBar,
  };
};
